import { noCacheUrl } from 'components/VisualStudioPlayground/Shapes/ImageShape/helpers'
import { sha1Hex } from 'utils'

/**
 * Converts an image URL from Cloudinary to a URL with a different file type.
 * @param url The original URL.
 * E.g. https://res.cloudinary.com/almanac/image/upload/q_auto,f_auto/v1694092406/workspace_portal_uploads/wkm7mjxlahcsgim559fe.jpg
 * @param type The new file type.
 * Cloudinary supports: JPG, PNG, GIF, BMP, TIFF, ICO, PDF, EPS, PSD, SVG, WebP, JXR, and WDP
 * @returns The new URL.
 */
export const convertCloudinaryImageURL = (url: string, type: DownloadableFormat) => {
  // Make sure url is HTTPS
  url = url.replace(/^http:/, 'https:')
  // remove  /q_auto,f_auto from url
  url = url.replace(/\/q_auto,f_auto/, '')
  // remove previous type
  url = url.replace(/\.[a-z]+$/, '')
  // add type
  url += `.${type}`
  return url
}

const forceDownload = (blobUrl: string, filename: string) => {
  const a = document.createElement('a')
  a.download = filename
  a.href = blobUrl
  // For Firefox must explicity add element to DOM
  document.body.appendChild(a)
  a.click()
  a.remove()
}

export type DownloadableFormat = 'jpg' | 'png' | 'gif'

export const downloadImageAs = (originalUrl: string, type: DownloadableFormat) => {
  const filename = sha1Hex(originalUrl) + '.' + type

  let url = originalUrl

  if (originalUrl.includes('res.cloudinary.com')) {
    url = convertCloudinaryImageURL(originalUrl, type)
  }

  fetch(noCacheUrl(url))
    .then((response) => response.blob())
    .then((blob) => {
      let blobUrl = window.URL.createObjectURL(blob)
      forceDownload(blobUrl, filename)
    })
}
